import { useMemo } from "react";

import type { MusicData } from "../../music-data/types";

export interface SongSlidePage {
  pageIndex: number;
  startMeasure: number;
  endMeasure: number;
}

export function groupMeasuresIntoPages(measureCount: number): SongSlidePage[] {
  if (measureCount <= 0) return [];
  const pages: SongSlidePage[] = [];
  for (let i = 0; i < measureCount; i += 4) {
    pages.push({
      pageIndex: pages.length,
      startMeasure: i,
      endMeasure: Math.min(i + 4, measureCount),
    });
  }
  return pages;
}

export function useSongSlidePages(musicData: MusicData | null): SongSlidePage[] {
  return useMemo(() => {
    if (!musicData) return [];
    const measureCount = Math.max(0, ...musicData.parts.map((p) => p.measures.length));
    return groupMeasuresIntoPages(measureCount);
  }, [musicData]);
}
